import type { RegisteredComponent } from "@builder.io/sdk-react";
import AthletesCreators from "./components/AthletesCreators";
import Chat from "./components/Chat";
import Content from "./components/Content";
import ContentGrid from "./components/ContentGrid";
import Hero from "./components/Hero";
import LatestCollections from "./components/LatestCollections";
import MarqueeComponent from "./components/Marquee";
import OurProcess from "./components/OurProcess";

export const CUSTOM_COMPONENTS: RegisteredComponent[] = [
  {
    component: AthletesCreators,
    name: "AthletesCreators",
    inputs: [
      {
        name: "image1",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "title1",
        type: "text",
        required: true,
      },
      {
        name: "description1",
        type: "text",
        required: true,
      },
      {
        name: "button1Text",
        type: "text",
        required: true,
      },
      {
        name: "button1Link",
        type: "url",
        required: true,
      },

      {
        name: "image2",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "title2",
        type: "text",
        required: true,
      },
      {
        name: "description2",
        type: "text",
        required: true,
      },
      {
        name: "button2Text",
        type: "text",
        required: true,
      },
      {
        name: "button2Link",
        type: "url",
        required: true,
      },

      {
        name: "image3",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "title3",
        type: "text",
        required: true,
      },
      {
        name: "description3",
        type: "text",
        required: true,
      },
      {
        name: "button3Text",
        type: "text",
        required: true,
      },
      {
        name: "button3Link",
        type: "url",
        required: true,
      },
    ],
  },
  {
    component: Chat,
    name: "Chat",
    inputs: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "title2",
        type: "string",
        required: true,
      },
      {
        name: "image",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "shopLink",
        type: "url",
        required: true,
      },
    ]
  },
  {
    component: Content,
    name: "Content",
    inputs: [
      {
        name: "content",
        type: "richText",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
  },
  {
    component: ContentGrid,
    name: "ContentGrid",
    inputs: [
      {
        name: "blocks",
        type: "list",
        required: true,
        hideFromUI: false,
        subFields: [
          {
            name: "title",
            type: "string",
            required: true,
          },
          {
            name: "description",
            type: "richText",
            required: true,
          },
        ],
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
  },
  {
    component: Hero,
    name: "Hero",
    inputs: [
      {
        name: "buttonLink",
        type: "string",
        required: true,
      },
      {
        name: "buttonText",
        type: "string",
        required: true,
      },
      {
        name: "heroBanner",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
    ],
  },
  {
    component: LatestCollections,
    name: "LatestCollections",
  },
  {
    component: MarqueeComponent,
    name: "MarqueeComponent",
    inputs: [
      {
        name: "parts",
        type: "list",
        required: true,
        subFields: [
          {
            name: "text",
            type: "string",
            required: true,
          },
        ],
      },
    ],
  },
  {
    component: OurProcess,
    name: "OurProcess",
    //title,image1,image2,image3,buttonLink,buttonText
    inputs: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "image1",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "image2",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "image3",
        type: "file",
        allowedFileTypes: ["jpeg", "png", "jpg"],
        required: true,
      },
      {
        name: "buttonLink",
        type: "string",
        required: true,
      },
      {
        name: "buttonText",
        type: "string",
        required: true,
      },
    ]
  },
];
